export default __webpack_public_path__ + "820f038fd1249fcf96987a39e7fc3af6.webp";